import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, Sparkles, ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import { IMAGES } from "../data/site";

const DJ_KURT = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/dd1ww1so_Dj%20Kurt%20Verheyen.jpg";
const DJ_DYSFUNKSHUNAL = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/mmqpent1_DJ%20Dysfunkshunal%20press%20pic%2010.jpg";
const DJ_SHANE_D = "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/2lh37vl8_Shane-D%20%282%29.jpg";
const DJ_KEZZE = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/aqc0mg5p_Kezze.png";
const DJ_ARN = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/68neyr93_Dj%20A.R.N%20%281%29.jpg";
const DJ_LOBEL = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/lgecwgex_Lobel%20%281%29.jpeg";
const DJ_RADIO_BOTANIQUE = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/ot08ag5n_radio%20botanique.jpg";
const DJ_SMASHED = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/mtj5ru1x_Smashed%20Dj%27s.jpeg";
const DJ_PIERRE_TOTAL = "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/6entc1gs_Pierre%20total%20%282%29.jpeg";
const VIBRATIONZ_LINEUP = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/l7g21aqu_Vibrationz%201.png";
const SMACK_THAT_VISUAL_LINEUP = "https://customer-assets.emergentagent.com/job_mechelen-summer/artifacts/qr0v4j04_visual%20smack%20that%20%282%29.png";
const LATIN_BEACH_NIGHTS_VISUAL = "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/i8ay0y2b_ChatGPT%20Image%2014%20jul%202026%2C%2001_46_24.png";
const MAANROCK_DJ_RALLY_VISUAL = "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/tc89dmpe_maanrock%20dj%20rally%20visual.jpg";
const RUM_AND_BASS_VISUAL = "https://customer-assets-jt897jd0.emergentagent.net/job_mechelen-summer/artifacts/nir40mf0_Rum%20%26%20bass.png";

const SALSA_LATIN_LINES = [
  "19u: gratis initiatie",
  "19u30: gratis initiatie voor alle niveaus",
  "20u – 00u: DJ El Capitan",
];

const RUM_BASS_LINES = [
  "20u – 21u: Dash",
  "21u – 22u: Jugglerz showcase",
  "22u – 23u: MT",
  "23u – 24u: Progmatic",
];

const programme = [
  { day: "Donderdag", date: "16/07", hours: "13u – 00u", time: "Vanaf 20u", event: "Opening met DJ A.R.N.", category: "Opening", image: DJ_ARN },
  { day: "Vrijdag", date: "17/07", hours: "13u – 01u", time: "Vanaf 20u", event: "PARTY met DJ Dysfunkshunal", category: "Party", image: DJ_DYSFUNKSHUNAL },
  { day: "Zaterdag", date: "18/07", hours: "13u – 01u", time: "Vanaf 20u", event: "Maanrock DJ Rally", category: "DJ Night", image: MAANROCK_DJ_RALLY_VISUAL, link: { label: "Meer info", href: "https://vi.be/platform/maanrockrally/calls/MaanrockDjRally2026" } },
  { day: "Zondag", date: "19/07", hours: "13u – 00u", event: "Summer Vibes", category: "Summer Vibes" },
  { day: "Maandag", date: "20/07", hours: "13u – 01u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Woensdag", date: "22/07", hours: "13u – 00u", time: "Vanaf 18u", event: "Wednesday Afterwork met Lobel & Mr Prosecco", category: "Afterwork", image: DJ_LOBEL },
  { day: "Donderdag", date: "23/07", hours: "13u – 00u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Vrijdag", date: "24/07", hours: "13u – 02u", time: "Vanaf 20u", event: "DJ Night met Kurt Verheyen & Shane-D", category: "DJ Night", images: [{ src: DJ_KURT, alt: "Kurt Verheyen" }, { src: DJ_SHANE_D, alt: "Shane-D" }] },
  { day: "Zaterdag", date: "25/07", hours: "13u – 02u", time: "Vanaf 20u", event: "Gastconcept ‘VIBRATIONZ’ neemt over", category: "Party", extraCat: "Gastconcept", image: VIBRATIONZ_LINEUP, link: { label: "Bekijk op Instagram", href: "https://www.instagram.com/p/DZe0W3zDnzj/?img_index=1" } },
  { day: "Zondag", date: "26/07", hours: "13u – 00u", event: "Summer Vibes", category: "Summer Vibes" },
  { day: "Maandag", date: "27/07", hours: "13u – 00u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Dinsdag", date: "28/07", hours: "13u – 00u", time: "Vanaf 20u", lines: RUM_BASS_LINES, event: "Rum & Bass", category: "Party", image: RUM_AND_BASS_VISUAL },
  { day: "Woensdag", date: "29/07", hours: "13u – 00u", time: "Vanaf 18u", event: "Wednesday Afterwork met Smack That", category: "Afterwork", extraCat: "Gastconcept", image: SMACK_THAT_VISUAL_LINEUP, link: { label: "Bekijk op Instagram", href: "https://www.instagram.com/p/DZXHLj2N7w6/" } },
  { day: "Donderdag", date: "30/07", hours: "13u – 00u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Vrijdag", date: "31/07", hours: "13u – 02u", time: "Vanaf 20u", event: "Party met Dysfunkshunal", category: "Party", image: DJ_DYSFUNKSHUNAL },
  { day: "Zaterdag", date: "01/08", hours: "13u – 02u", time: "Vanaf 20u", event: "Nineties & Nillies Party met Smashed Dj's", category: "Party", image: DJ_SMASHED },
  { day: "Zondag", date: "02/08", hours: "13u – 00u", event: "Summer Vibes", category: "Summer Vibes" },
  { day: "Maandag", date: "03/08", hours: "13u – 00u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Dinsdag", date: "04/08", hours: "13u – 00u", event: "Summer Vibes", category: "Summer Vibes" },
  { day: "Woensdag", date: "05/08", hours: "13u – 00u", time: "Vanaf 18u", event: "Wednesday Afterwork met Radio Botanique", category: "Afterwork", image: DJ_RADIO_BOTANIQUE },
  { day: "Donderdag", date: "06/08", hours: "13u – 00u", lines: SALSA_LATIN_LINES, event: "Latin Beach Nights", category: "Salsa", image: LATIN_BEACH_NIGHTS_VISUAL },
  { day: "Vrijdag", date: "07/08", hours: "13u – 02u", time: "Vanaf 20u", event: "DJ Night met Kurt Verheyen & Kezze", category: "DJ Night", images: [{ src: DJ_KURT, alt: "Kurt Verheyen" }, { src: DJ_KEZZE, alt: "Kezze" }] },
  { day: "Zaterdag", date: "08/08", hours: "13u – 02u", time: "Vanaf 20u", event: "Gastconcept ‘L'Eau De Vie’ neemt over", category: "Party", extraCat: "Gastconcept", link: { label: "Bekijk op Instagram", href: "https://www.instagram.com/leaudevie_official/" } },
  { day: "Zondag", date: "09/08", hours: "13u – 00u", time: "Vanaf 20u", event: "Slotavond met Pierre Total", category: "Slotavond", image: DJ_PIERRE_TOTAL },
];

// Category palette consistent with site identity
const categoryStyles = {
  "Opening":      { dot: "bg-[#ed6a1a]", chip: "bg-[#ed6a1a]/12 text-[#c54508] border-[#ed6a1a]/30" },
  "Slotavond":    { dot: "bg-[#ed6a1a]", chip: "bg-[#ed6a1a]/12 text-[#c54508] border-[#ed6a1a]/30" },
  "Summer Vibes": { dot: "bg-[#f4a261]", chip: "bg-[#f4a261]/18 text-[#a05a18] border-[#f4a261]/35" },
  "Salsa":        { dot: "bg-[#35d3be]", chip: "bg-[#35d3be]/15 text-[#0a7c70] border-[#35d3be]/35" },
  "Afterwork":    { dot: "bg-[#e8b14d]", chip: "bg-[#e8b14d]/18 text-[#8a5e0a] border-[#e8b14d]/35" },
  "Party":        { dot: "bg-[#f4512a]", chip: "bg-[#f4512a]/13 text-[#a8330e] border-[#f4512a]/35" },
  "DJ Night":     { dot: "bg-[#f4512a]", chip: "bg-[#f4512a]/13 text-[#a8330e] border-[#f4512a]/35" },
  "Gastconcept":  { dot: "bg-[#9c70d6]", chip: "bg-[#9c70d6]/15 text-[#5c3b9a] border-[#9c70d6]/35" },
};

const FILTERS = ["Alles", "Summer Vibes", "Salsa", "Afterwork", "Party / DJ", "Gastconcept"];

const featured = [
  { event: "Opening met DJ A.R.N.", day: "Donderdag 16/07", image: DJ_ARN },
  { event: "PARTY met DJ Dysfunkshunal", day: "Vrijdag 17/07", image: DJ_DYSFUNKSHUNAL },
  { event: "DJ Night met Kurt Verheyen & Shane-D", day: "Vrijdag 24/07", images: [{ src: DJ_KURT, alt: "Kurt Verheyen" }, { src: DJ_SHANE_D, alt: "Shane-D" }] },
  { event: "Nineties & Nillies Party", day: "Zaterdag 01/08", image: DJ_SMASHED },
  { event: "Slotavond met Pierre Total", day: "Zondag 09/08", image: DJ_PIERRE_TOTAL },
];

export default function LineUp() {
  const [active, setActive] = useState("Alles");

  const filtered = useMemo(() => {
    if (active === "Alles") return programme;
    if (active === "Party / DJ")
      return programme.filter((p) => p.category === "Party" || p.category === "DJ Night");
    if (active === "Gastconcept")
      return programme.filter((p) => p.category === "Gastconcept" || p.extraCat === "Gastconcept");
    return programme.filter((p) => p.category === active);
  }, [active]);

  return (
    <>
      <Seo
        title="Line-up 2026 | Mechelen Beach"
        description="Ontdek het avondprogramma van Mechelen Beach 2026 met summer vibes, salsa-avonden, afterworks, DJ nights en slotavond op het Douaneplein in Mechelen."
      />

      <PageHero
        eyebrow="Elke dag open vanaf 13u"
        title="Line-up 2026"
        subtitle="Ontdek het avondprogramma van Mechelen Beach 2026. Van summer vibes en salsa-avonden tot DJ nights, afterworks en slotavond: er valt elke week iets te beleven op het Douaneplein."
        image={IMAGES.lineupParty}
        imageAlt="Volle dansvloer en party sfeer op Mechelen Beach"
        primaryCta={{ label: "Bekijk het programma", to: "/programma" }}
        secondaryCta={{ label: "Bekijk openingsuren", to: "/praktische-info/openingsuren" }}
      />

      {/* FEATURED — Niet te missen */}
      <section data-testid="lineup-featured" className="bg-[#fdf8ec] py-14 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3">
            <Sparkles className="h-5 w-5 text-[#ed6a1a]" />
            <span className="eyebrow !mt-0">Niet te missen</span>
          </div>
          <h2 className="font-display mt-4 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-[#2b1c10]">
            Topavonden van deze editie
          </h2>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {featured.map((f, i) => (
              <div
                key={f.event}
                data-testid={`lineup-featured-${i}`}
                className="relative rounded-2xl border border-[#ed6a1a]/30 bg-gradient-to-br from-white to-[#fff3e3] overflow-hidden flex flex-col"
              >
                {f.image && (
                  <div className="aspect-[4/3] w-full overflow-hidden bg-[#0b1722] flex items-center justify-center">
                    <img
                      src={f.image}
                      alt={f.event}
                      loading="lazy"
                      className="max-w-full max-h-full object-contain"
                    />
                  </div>
                )}
                {Array.isArray(f.images) && f.images.length > 0 && (
                  <div className="aspect-[4/3] w-full overflow-hidden bg-[#0b1722] grid grid-cols-2 gap-px">
                    {f.images.map((im) => (
                      <div key={im.src} className="relative overflow-hidden bg-[#0b1722] flex items-center justify-center">
                        <img
                          src={im.src}
                          alt={im.alt}
                          loading="lazy"
                          className="max-w-full max-h-full object-contain"
                        />
                        <span className="absolute bottom-1 left-1 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider bg-white/85 text-[#2b1c10]">
                          {im.alt}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                <div className="p-5 flex-1">
                  <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#ed6a1a]">
                    {f.day}
                  </span>
                  <p className="font-display mt-2 text-base sm:text-lg font-semibold text-[#2b1c10] leading-snug">
                    {f.event}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROGRAMMA */}
      <section id="avondprogramma" data-testid="lineup-programma" className="bg-sand-2 py-16 sm:py-24 scroll-mt-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <span className="eyebrow">Programma</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#2b1c10] leading-[1.05]">
              Avondprogramma 2026
            </h2>
            <p className="mt-4 text-sm sm:text-base text-[#6b5945]">
              Elke dag open vanaf 13u. Programma onder voorbehoud van wijzigingen.
            </p>
          </div>

          {/* Filters */}
          <div className="mt-8 flex flex-wrap gap-2">
            {FILTERS.map((f) => {
              const isActive = f === active;
              return (
                <button
                  key={f}
                  type="button"
                  data-testid={`filter-${f.toLowerCase().replace(/[^a-z]/g, "")}`}
                  onClick={() => setActive(f)}
                  className={`inline-flex items-center px-4 py-2 rounded-full text-xs font-bold uppercase tracking-[0.12em] border transition-colors ${
                    isActive
                      ? "bg-[#ed6a1a] text-white border-[#ed6a1a]"
                      : "bg-white text-[#2b1c10] border-[#ebd9b5] hover:border-[#ed6a1a]/50 hover:text-[#ed6a1a]"
                  }`}
                >
                  {f}
                </button>
              );
            })}
          </div>

          {/* Cards grid */}
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {filtered.map((p, i) => {
              const s = categoryStyles[p.category] || categoryStyles["Summer Vibes"];
              const extraStyle = p.extraCat ? categoryStyles[p.extraCat] : null;
              return (
                <article
                  key={`${p.date}-${p.event}`}
                  data-testid={`programma-item-${i}`}
                  className="group relative bg-white rounded-2xl border border-[#ebd9b5] overflow-hidden hover:border-[#ed6a1a]/45 hover:-translate-y-0.5 transition-all duration-300"
                >
                  {p.image && (
                    <div className="aspect-[16/9] w-full overflow-hidden bg-[#0b1722] flex items-center justify-center">
                      <img
                        src={p.image}
                        alt={p.event}
                        loading="lazy"
                        className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-[1.03]"
                      />
                    </div>
                  )}
                  {Array.isArray(p.images) && p.images.length > 0 && (
                    <div className="aspect-[16/9] w-full overflow-hidden bg-[#0b1722] grid grid-cols-2 gap-px">
                      {p.images.map((im) => (
                        <div key={im.src} className="relative overflow-hidden bg-[#0b1722] flex items-center justify-center">
                          <img
                            src={im.src}
                            alt={im.alt}
                            loading="lazy"
                            className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-[1.03]"
                          />
                          <span className="absolute bottom-1.5 left-1.5 px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider bg-white/85 text-[#2b1c10]">
                            {im.alt}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                  <div className="p-5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-[#ed6a1a]">
                        {p.day}
                      </p>
                      <p className="font-display text-2xl sm:text-[1.65rem] font-semibold text-[#2b1c10] leading-none mt-1">
                        {p.date}
                      </p>
                    </div>
                    <div className="flex flex-col items-end gap-1.5 flex-wrap">
                      <span
                        className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.12em] border ${s.chip}`}
                      >
                        <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
                        {p.category === "Party" ? "Party / DJ" : p.category === "DJ Night" ? "Party / DJ" : p.category}
                      </span>
                      {extraStyle && (
                        <span
                          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-[0.12em] border ${extraStyle.chip}`}
                        >
                          <span className={`h-1.5 w-1.5 rounded-full ${extraStyle.dot}`} />
                          {p.extraCat}
                        </span>
                      )}
                    </div>
                  </div>

                  <h3 className="font-display mt-5 text-lg sm:text-xl font-semibold text-[#2b1c10] leading-snug">
                    {p.event}
                  </h3>

                  {p.lines ? (
                    <div className="mt-4 space-y-1 text-sm text-[#2b1c10]">
                      {p.lines.map((ln) => (
                        <div key={ln} className="flex items-start gap-2">
                          <Clock className="h-3.5 w-3.5 text-[#ed6a1a] mt-0.5 shrink-0" />
                          <span>{ln}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="mt-4 text-sm">
                      <div className="flex items-center gap-2 text-[#2b1c10] font-semibold">
                        <Clock className="h-3.5 w-3.5 text-[#ed6a1a]" />
                        {p.time || p.hours}
                      </div>
                      {p.time && (
                        <p className="mt-1.5 text-[11px] text-[#8a7460] pl-5">
                          Strandbar open vanaf 13u
                        </p>
                      )}
                    </div>
                  )}

                  {p.link && (
                    <a
                      href={p.link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`lineup-link-${i}`}
                      className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[#ed6a1a] hover:text-[#c54508] transition-colors"
                    >
                      {p.link.label}
                      <ArrowRight className="h-3.5 w-3.5" />
                    </a>
                  )}
                  </div>
                </article>
              );
            })}
          </div>

          {filtered.length === 0 && (
            <p className="mt-10 text-center text-[#6b5945]">Geen avonden in deze categorie.</p>
          )}
        </div>
      </section>

      {/* POSTER */}
      <section data-testid="lineup-poster" className="bg-[#fdf8ec] py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="eyebrow">Poster</span>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
              Volledig overzicht
            </h2>
            <p className="mt-4 text-base text-[#6b5945]">
              Bekijk hieronder het volledige overzicht van het avondprogramma.
            </p>
          </div>
          <a
            href={IMAGES.lineupPoster}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="lineup-poster-link"
            className="mt-8 block rounded-2xl overflow-hidden shadow-[0_18px_40px_-12px_rgba(43,28,16,0.25)] border border-[#ebd9b5] bg-white hover:shadow-[0_22px_48px_-12px_rgba(43,28,16,0.35)] transition-shadow"
          >
            <img
              src={IMAGES.lineupPoster}
              alt="Line-up Mechelen Beach 2026 — avondprogramma poster"
              className="w-full h-auto object-contain"
              loading="lazy"
            />
          </a>
        </div>
      </section>

      {/* BOTTOM CTA */}
      <section className="bg-sand-2 py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-[#2b1c10]">
            Zin in zomeravonden op Mechelen Beach?
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#6b5945]">
            Kom langs voor een drankje, muziek en sfeer op het Douaneplein.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/praktische-info/openingsuren" data-testid="lineup-cta-openingsuren" className="btn-primary">
              Bekijk openingsuren
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link to="/praktische-info/bereikbaarheid" data-testid="lineup-cta-bereik" className="btn-ghost">
              Bekijk bereikbaarheid
              <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
